export default {
  loading_menu: 'Cargando menú...',
};
